document.addEventListener("DOMContentLoaded", function(event) { 
  // Get all the required elements
  const cartRemoveBtn = document.getElementById('cart_remove_btn');
  const cartApplyBtn = document.getElementById('cart_apply_btn');
  const discountInput = document.getElementById('cart_discount_input');
  const standaloneTag = document.getElementById('standalone_coupon_tag');
  const messageDiv = document.getElementById('cart_discount_message');
  const tagRemoveBtn = document.getElementById('standalone_tag_remove');
  
  // Storage for applied discount codes - now also check mini-cart storage
  let appliedDiscounts = [];
  const miniCartDiscount = localStorage.getItem("shopify_discount_code");
  const storedDiscounts = localStorage.getItem("shopify_discount_codes");
  
  if (storedDiscounts) {
    appliedDiscounts = JSON.parse(storedDiscounts);
  }
  
  // If mini-cart has a discount that's not in our array, add it
  if (miniCartDiscount && !appliedDiscounts.includes(miniCartDiscount)) {
    appliedDiscounts.push(miniCartDiscount);
    localStorage.setItem("shopify_discount_codes", JSON.stringify(appliedDiscounts));
  }
  
  // Check actual cart state to see if discounts are applied
  fetchCartContents()
    .then(cartData => {
      let foundCartDiscount = false;
      
      // If cart has discounts, extract the code if possible
      if (cartData.cart_level_discount_applications && cartData.cart_level_discount_applications.length > 0) {
        const discountApp = cartData.cart_level_discount_applications[0];
        if (discountApp && discountApp.title) {
          // Extract discount code from the title
          const codeMatch = discountApp.title.match(/^([A-Z0-9_\-]+)/i);
          if (codeMatch && codeMatch[1]) {
            const cartDiscountCode = codeMatch[1];
            foundCartDiscount = true;
            
            // Add to our storage if not already present
            if (!appliedDiscounts.includes(cartDiscountCode)) {
              appliedDiscounts.push(cartDiscountCode);
              localStorage.setItem("shopify_discount_codes", JSON.stringify(appliedDiscounts));
              
              // Also update mini-cart storage for consistency
              localStorage.setItem("shopify_discount_code", cartDiscountCode);
            }
          }
        }
      }
      
      // If we have codes in storage but none in cart, try to apply the latest one
      if (appliedDiscounts.length > 0 && !foundCartDiscount) {
        const latestCode = appliedDiscounts[appliedDiscounts.length - 1];
        // Try to apply the code
        applyDiscount(latestCode, true);
      } else {
        // Initialize UI based on current state
        initializeUI();
      }
    })
    .catch(error => {
      console.error("Error fetching cart:", error);
      // Initialize UI based on localStorage
      initializeUI();
    });
  
  // Initialize the UI based on applied discounts
  function initializeUI() {
    console.log("Initializing discount UI");
    console.log("Applied discounts:", appliedDiscounts);
    
    if (appliedDiscounts.length > 0) {
      // We have at least one discount code applied
      const latestCode = appliedDiscounts[appliedDiscounts.length - 1];
      
      // Show the discount code in the input
      if (discountInput) {
        discountInput.value = latestCode;
      }
      
      // Show the remove button, hide the apply button
      if (cartRemoveBtn) cartRemoveBtn.style.display = 'inline-block';
      if (cartApplyBtn) cartApplyBtn.style.display = 'none';
      
      // Show the discount tag
      updateDiscountTag(latestCode);
    } else {
      // No discount codes applied
      // Hide the discount tag
      if (standaloneTag) standaloneTag.style.display = 'none';
      
      // Clear the input
      if (discountInput) discountInput.value = '';
      
      // Show the apply button, hide the remove button
      if (cartRemoveBtn) cartRemoveBtn.style.display = 'none';
      if (cartApplyBtn) cartApplyBtn.style.display = 'inline-block';
    }
  }
  
  // Update the discount tag with the given code
  function updateDiscountTag(code) {
    if (!standaloneTag) return;
    
    // Find the span element inside the tag
    const spanElement = document.getElementById('discount_code_display');
    if (spanElement) {
      if (code && code.toLowerCase() === 'welcome5') {
        spanElement.textContent = 'WELCOME5 - $5.00 OFF';
      } else if (code) {
        spanElement.textContent = code.toUpperCase();
      }
    }
    
    // Show the tag
    standaloneTag.style.display = 'flex';
  }
  
  // Clear all applied discounts
  function clearDiscount() {
    console.log("Clearing discount");
    
    // Clear the applied discounts array
    appliedDiscounts = [];
    localStorage.removeItem("shopify_discount_codes");
    
    // Also clear mini-cart storage
    localStorage.removeItem("shopify_discount_code");
    
    // Hide the discount tag
    if (standaloneTag) standaloneTag.style.display = 'none';
    
    // Clear the input and message
    if (discountInput) discountInput.value = '';
    if (messageDiv) messageDiv.textContent = '';
    
    // Show the apply button, hide the remove button
    if (cartRemoveBtn) cartRemoveBtn.style.display = 'none';
    if (cartApplyBtn) cartApplyBtn.style.display = 'inline-block';
    
    // Call the Shopify API to clear discounts and redirect back to cart
    window.location.href = '/discount/clear?redirect=/cart';
  }
  
  // Apply a discount code
  async function applyDiscount(code, silentMode = false) {
    console.log("Applying discount:", code);
    
    if (!silentMode) {
      // Show loading state
      if (cartApplyBtn) {
        cartApplyBtn.textContent = 'Applying...';
        cartApplyBtn.disabled = true;
      }
    }
    
    try {
      // Store the discount code in storage
      if (!appliedDiscounts.includes(code)) {
        appliedDiscounts.push(code);
      }
      localStorage.setItem("shopify_discount_codes", JSON.stringify(appliedDiscounts));
      
      // Also update mini-cart storage
      localStorage.setItem("shopify_discount_code", code);
      
      // Call the Shopify API to apply the discount
      const response = await fetch('/discount/' + encodeURIComponent(code));
      
      if (response.ok) {
        // Success - refresh the page or update UI without refresh
        if (!silentMode) {
          window.location.reload();
        } else {
          // Update UI without reload
          updateDiscountTag(code);
          if (cartRemoveBtn) cartRemoveBtn.style.display = 'inline-block';
          if (cartApplyBtn) cartApplyBtn.style.display = 'none';
        }
      } else {
        // Error - clear the discount code and show error
        throw new Error('Invalid discount code');
      }
    } catch (error) {
      console.error('Error applying discount:', error);
      
      if (!silentMode) {
        // Remove the code from applied discounts
        appliedDiscounts = appliedDiscounts.filter(d => d !== code);
        localStorage.setItem("shopify_discount_codes", JSON.stringify(appliedDiscounts));
        
        // Clear mini-cart storage if it matches this code
        if (localStorage.getItem("shopify_discount_code") === code) {
          localStorage.removeItem("shopify_discount_code");
        }
        
        // Show error message
        if (messageDiv) {
          messageDiv.textContent = error.message;
          messageDiv.style.color = 'var(--color-accent-1)';
        }
        
        // Reset button state
        if (cartApplyBtn) {
          cartApplyBtn.disabled = false;
          cartApplyBtn.textContent = 'Apply';
        }
      }
    }
  }
  
  // Helper function to fetch cart data
  function fetchCartContents() {
    return fetch('/cart.js')
      .then(response => response.json())
      .catch(error => {
        throw error;
      });
  }
  
  // Add event listeners
  if (cartRemoveBtn) {
    cartRemoveBtn.addEventListener("click", function(e) {
      e.preventDefault();
      clearDiscount();
    });
  }
  
  if (cartApplyBtn) {
    cartApplyBtn.addEventListener("click", function(e) {
      e.preventDefault();
      if (discountInput && discountInput.value.trim()) {
        applyDiscount(discountInput.value.trim());
      } else if (messageDiv) {
        messageDiv.textContent = 'Please enter a discount code';
        messageDiv.style.color = 'var(--color-accent-1)';
      }
    });
  }
  
  // Add event listeners to all remove buttons within the discount tag
  if (tagRemoveBtn) {
    tagRemoveBtn.addEventListener("click", function(e) {
      e.preventDefault();
      e.stopPropagation();
      clearDiscount();
    });
  }
  
  // If the standalone tag has any buttons, add listeners to them
  if (standaloneTag) {
    const buttons = standaloneTag.querySelectorAll('button');
    buttons.forEach(button => {
      button.addEventListener("click", function(e) {
        e.preventDefault();
        e.stopPropagation();
        clearDiscount();
      });
    });
  }
}); 